// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

// Styles
import './dont-have-id-modal.scss';

// Components
import { Trans } from '../../..';

import { Modal } from '../../modals';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import { closeModal } from '../../../../reducers/modal/modalActions';
import {
  CREATE_ACCOUNT_STEPS,
  setOutOfState,
} from '../../../../reducers/createAccount/createAccountActions';

const DontHaveIdModal = ({ body, onNoId }) => {
  const dispatch = useDispatch();

  // NEED TO REMOVE THIS AFTER TESTING - KEPT AS A PLACE HOLDER FOR MOCKING OUT OF STATE FLOW
  const handleNoIdClick = () => {
    // Set the out of state flag first
    dispatch(setOutOfState(true));

    if (onNoId) {
      onNoId();
    }
    dispatch(closeModal('DontHaveIdModal'));
    dispatch(push(`/create-account/${CREATE_ACCOUNT_STEPS.EMAIL}`));
  };

  return (
    <Modal name="DontHaveIdModal" className="dont-have-id-modal">
      <h2 className="dont-have-id-modal-title">
        <Trans file="Modals" id="CreateTxTAccountNoTxID" fallback="" />
      </h2>
      {body && <div className="modal-content">{body}</div>}
      <div className="dont-have-id-modal-btns">
        <ButtonPrimary
          onClick={() => {
            dispatch(closeModal('DontHaveIdModal'));
          }}
        >
          <Trans file="Labels" id="gotIt" />
        </ButtonPrimary>
      </div>
    </Modal>
  );
};

DontHaveIdModal.propTypes = {
  body: PropTypes.node,
  // NEED TO REMOVE THIS AFTER TESTING - KEPT AS A PLACE HOLDER FOR MOCKING OUT OF STATE FLOW
  onNoId: PropTypes.func,
};

export default DontHaveIdModal;
